module.exports = __webpack_public_path__ + "img/logo__.5940ecd5.png";